import React from 'react';
import { cx } from '../../../../../ui/components/cx';
import './ActionTile.scss';

export const actionTileClass = 'ds-action-tile';

interface ActionTileContentProps {
  icon?: React.ReactNode;
  label: React.ReactNode;
}

/** Icon + label body of a tile. Use inside an <a>/<Link className={actionTileClass}> for link tiles. */
export const ActionTileContent: React.FC<ActionTileContentProps> = ({ icon, label }) => (
  <>
    {icon && <span className="ds-action-tile__icon">{icon}</span>}
    <span className="ds-action-tile__label">{label}</span>
  </>
);

export interface ActionTileProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactNode;
  label: React.ReactNode;
}

/**
 * Square-ish quick-action button (icon over a short label) for control-panel rows,
 * e.g. "Reset OTP", "View Dashboard". Lay several out with a grid in the page.
 */
const ActionTile = React.forwardRef<HTMLButtonElement, ActionTileProps>(
  ({ icon, label, className, type, ...rest }, ref) => (
    <button ref={ref} type={type ?? 'button'} className={cx(actionTileClass, className)} {...rest}>
      <ActionTileContent icon={icon} label={label} />
    </button>
  ),
);
ActionTile.displayName = 'ActionTile';

export default ActionTile;
